import { useState, useCallback } from 'react';

export const useProjectCostOverridesViewSummary = () => {
  const [viewSummary, setViewSummary] = useState(false);

  const onViewSummaryClick = useCallback(() => {
    setViewSummary(prev => !prev);
  }, []);

  return {
    viewSummary,
    onViewSummaryClick
  };
};

export default useProjectCostOverridesViewSummary;
